import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'sales-source:unlocked'

/** Shared team password for the Sales Source hub. */
export const SITE_PASSWORD = 'SalesSource2026'

export function useSessionUnlock() {
  const [unlocked, setUnlocked] = useState(false)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    try {
      setUnlocked(window.sessionStorage.getItem(STORAGE_KEY) === 'true')
    } catch {
      setUnlocked(false)
    }
    setReady(true)
  }, [])

  const unlock = useCallback(() => {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, 'true')
    } catch {
      /* session storage unavailable — stay unlocked in memory only */
    }
    setUnlocked(true)
  }, [])

  const lock = useCallback(() => {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY)
    } catch {
      /* noop */
    }
    setUnlocked(false)
  }, [])

  return { unlocked, ready, unlock, lock }
}
